import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-110af4d1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "Speakers",
  class: "people"
}
const _hoisted_2 = { class: "people__header" }
const _hoisted_3 = { class: "people__header-menu" }
const _hoisted_4 = {
  key: 0,
  class: "people__list"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "people__person-name" }
const _hoisted_7 = { class: "people__person-company" }
const _hoisted_8 = { class: "people__person-roles" }

import { ref, computed, onMounted } from 'vue'
import SectionTitle from "@/components/SectionTitle.vue"
import { Roles, people } from "@/components/people"
import Image from "@/components/Image.vue"
import {getPersonImage, peopleData } from '@/components/usePeople'

// onMounted( async () => {
//   fetchPeopleData()
// })


export default /*#__PURE__*/_defineComponent({
  __name: 'People',
  setup(__props) {

const showPeopleWithRole = ref(Roles.ALL)

const selectedPeople = computed(() => {

  if (showPeopleWithRole.value === Roles.ALL) {
    return people;
  }
  return people.filter(person => person.roles.includes(showPeopleWithRole.value));
  
  // if (showPeopleWithRole.value === Roles.ALL) {
  //   return peopleData.value
  // }
  // return (peopleData.value).filter(person => person.roles.includes(showPeopleWithRole.value))
});

const headerMenuButtonClasses = (role: string) => `people__header-menu-button ${showPeopleWithRole.value === role ? 'people__header-menu-button-active' : ''}`


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SectionTitle, { title: "people" }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showPeopleWithRole.value = _unref(Roles).ALL)),
          class: _normalizeClass(headerMenuButtonClasses(_unref(Roles).ALL))
        }, "all", 2),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (showPeopleWithRole.value = _unref(Roles).SPEAKER)),
          class: _normalizeClass(headerMenuButtonClasses(_unref(Roles).SPEAKER))
        }, "speakers", 2),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (showPeopleWithRole.value = _unref(Roles).JUDGE)),
          class: _normalizeClass(headerMenuButtonClasses(_unref(Roles).JUDGE))
        }, "judges", 2),
        _createElementVNode("button", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (showPeopleWithRole.value = _unref(Roles).MENTOR)),
          class: _normalizeClass(headerMenuButtonClasses(_unref(Roles).MENTOR))
        }, "mentors", 2)
      ])
    ]),
    (selectedPeople.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedPeople.value, (person) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "people__person",
              key: person.name
            }, [
              (person.twitterLink)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: _normalizeClass({ 'people__person-image-twitter-link': person.twitterLink }),
                    href: person.twitterLink,
                    target: "_blank"
                  }, null, 10, _hoisted_5))
                : _createCommentVNode("", true),
              _createVNode(Image, {
                cssClass: ['people__person-image', {'people__person-image--purple-filter': !Boolean(person.isImageEdited)} ],
                src: _unref(getPersonImage)({person})
              }, null, 8, ["cssClass", "src"]),
              _createElementVNode("div", _hoisted_6, _toDisplayString(person.name), 1),
              _createElementVNode("div", _hoisted_7, _toDisplayString(person.company), 1),
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(person.roles, (role) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "people__person-role",
                    key: role
                  }, _toDisplayString(role), 1))
                }), 128))
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})